import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-portal-layout',
  standalone: true,
  imports: [],
  templateUrl: './portal.html',
  styleUrl: './portal.scss',
})
export class Portal {
  public logoSrc = '/img/white-logo.svg';
  @Input() showDeco = true;
  @Input() footerType = 1;
}
